<div class="program-image-container">
  <img alt="{{ title }} Main image" [src]="imageUrl" ogImageSource [imageSrc]="imageUrl" />
</div>
